export default class IamSilentSignInError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "IamSilentSignInError";
    }
}